import React from 'react'

import { Text } from '@wartek-id/text'
import { Link } from '@wartek-id/link'

import type { RemarkProps } from 'react-remark'

const components: RemarkProps['rehypeReactOptions']['components'] = {
  p: (props) => (
    <Text variant="body" className="mb-4" {...props}>
      {props.children}
    </Text>
  ),
  h1: (props) => (
    <Text as="h1" variant="heading-lg" className="!mb-2 !mt-4" {...props}>
      {props.children}
    </Text>
  ),
  h2: (props) => {
    return (
      <Text as="h2" variant="heading-md" className="!mb-2 !mt-3" {...props}>
        {props.children}
      </Text>
    )
  },
  h3: (props) => {
    return (
      <Text as="h3" variant="heading-sm" className="!mb-2 !mt-2" {...props}>
        {props.children}
      </Text>
    )
  },
  h4: (props) => (
    <Text as="h4" variant="subheading" className="!mb-2 !mt-1" {...props}>
      {props.children}
    </Text>
  ),
  h5: (props) => (
    <Text as="h5" variant="subheading-sm" className="!mb-2 !mt-1" {...props}>
      {props.children}
    </Text>
  ),
  h6: (props) => (
    <Text as="h6" variant="subheading-xs" {...props}>
      {props.children}
    </Text>
  ),
  a: (props) => (
    <Link {...props} style={{ wordBreak: 'break-word' }}>
      {props.children}
    </Link>
  ),
  img: (props) => <img {...props} alt="md-image" />,
  ul: (props) => (
    <ul className="ml-4" style={{ listStyle: 'outside' }} {...props}>
      <div className="ml-4">{props.children}</div>
    </ul>
  ),
  ol: (props) => {
    return (
      <ol {...props} className="ml-4" style={{ listStyle: 'auto' }}>
        <div className="ml-4">{props.children}</div>
      </ol>
    )
  },
  li: (props) => {
    return (
      <li {...props}>
        <Text variant="body" className="mb-4">
          {Array.isArray(props.children) ? (
            props.children.map((child, index) => (
              <React.Fragment key={index}>{child}</React.Fragment>
            ))
          ) : (
            <div className="pl-4">{props.children}</div>
          )}
        </Text>
      </li>
    )
  },
}

export default components
